export enum EFeedbackType {
  Report = 'report',
  Regenerate = 'regenerate',
  ThumbsDown = 'thumbs_down',
  ThumbsUp = 'thumbs_up'
}

export enum EFeedbackThumbsDownOptions {
  OffTopic = 'Off topic',
  Shallow = 'Shallow/no depth',
  Disinterested = 'Missunderstood me',
  Missunderstood = 'Disinterested',
  OutOfCharacter = 'Forgetful',
  Forgetful = 'Out of character'
}

export enum EFeedbackReportOptions {
  RepeatsItself = 'Repeats itself',
  NoSense = "Doesn't make sense",
  Confusing = 'Confusing',
  Wrong = 'Wrong',
  Offensive = 'Offensive'
}
